module.exports = __webpack_public_path__ + "img/thumbnail_BairdsTapir_f_normal.c84f4016.png";